import { GridColumnProps } from "@progress/kendo-react-grid";
import { CLASSNAME } from "utils/constant";
import { GrideDateFormatter } from "ui/Date";
//import styles from "styles.module.css";
import i18n from "../../../i18n";
import { NumericalCell, NumericalHeader } from "ui/grid/GridCommandCell";
import CellPopover from "ui/grid/DescriptionCell";

let t = i18n.t;

export const releasedPackageGridColumnItem = () => {
	const gridItems: GridColumnProps[] = [
		// {
		// 	field: "",
		// 	title: "",
		// 	width: "30px",
		// 	headerClassName: "no-border",
		// 	cell: (props) => <DotCell value={props.dataItem.status} />,
		// },
		{
			field: "registrationId",
			title: t("RegistrationIdShort"),
			width: "100px",
			headerClassName: "no-border",
		},
		{
			field: "packageId",
			title: t("Package"),
			//width: "150px",
			headerClassName: "no-border",
			width: "90px",
		},

		{
			field: "confirmedTime",
			title: t("ConfirmTime"),
			headerClassName: "no-border",
			cell: (props) => (
				<GrideDateFormatter
					date={props.dataItem.confirmedTime}
					formatType={"dd.MM.yyyy"}
				/>
			),
			// width: "110px",
		},
		{
			field: "vesselRegistrationId",
			title: t("VesselRegistrationId"),
		},
		{
			field: "vesselName",
			title: t("Vessel"),
			cell: (props) => <CellPopover {...props} />,
		},

		//{
		//	field: "buyerLedgerAccountNumber",
		//	title: t("Buyer"),
		//	cell: (props) => <CellPopover {...props} />,
		//	width: "90px",
		//},

		{
			field: "buyerName",
			title: t("BuyerName"),
			cell: (props) => <CellPopover {...props} />,
		},

		{
			field: "registeredTime",
			title: "Innm.Dato",
			headerClassName: "no-border",
			cell: (props) => (
				<GrideDateFormatter
					date={props.dataItem.registeredTime}
					formatType={"dd.MM.yyyy"}
				/>
			),
			width: "120px",
		},

		{ field: "salesType", title: t("Type"), width: "80px" },

		{
			field: "liveWeightKg",
			title: t("Weight"),
			width: "150px",
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
			cells: {
				data: (props) => <NumericalCell {...props} unit={"kg"} />,
				headerCell: (props) => <NumericalHeader {...props} />,
			},
		},
		{
			field: "amount",
			title: t("Value"),
			width: "150px",
			cells: {
				data: (props) => <NumericalCell {...props} unit={"kr"} />,
				headerCell: (props) => <NumericalHeader {...props} />,
			},
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
		},
	];
	return gridItems;
};

export const releasedPackageFrontGridColumnItem = () => {
	const gridItems: GridColumnProps[] = [
		// {
		// 	field: "",
		// 	title: "",
		// 	width: "30px",
		// 	headerClassName: "no-border",
		// 	cell: (props) => <DotCell value={props.dataItem.status} />,
		// },
		{
			field: "registrationId",
			title: t("RegistrationIdShort"),
			width: "100px",
			headerClassName: "no-border",
		},
		{
			field: "registrationId",
			title: t("RegistrationIdShort"),
			width: "100px",
			headerClassName: "no-border",
		},
		{
			field: "packageId",
			title: t("Package"),
			//width: "150px",
			headerClassName: "no-border",
			width: "90px",
		},

		{
			field: "confirmedTime",
			title: t("ConfirmTime"),
			headerClassName: "no-border",
			cell: (props) => (
				<GrideDateFormatter
					date={props.dataItem.confirmedTime}
					formatType={"dd.MM.yyyy"}
				/>
			),
			// width: "110px",
		},
		{
			field: "vesselRegistrationId",
			title: t("VesselRegistrationId"),
		},
		{
			field: "vesselName",
			title: t("Vessel"),
			cell: (props) => <CellPopover {...props} />,
		},

		//{
		//	field: "buyerLedgerAccountNumber",
		//	title: t("Buyer"),
		//	cell: (props) => <CellPopover {...props} />,
		//	width: "90px",
		//},

		{
			field: "buyerName",
			title: t("BuyerName"),
			cell: (props) => <CellPopover {...props} />,
		},

		{
			field: "registeredTime",
			title: "Innm.Dato",
			headerClassName: "no-border",
			cell: (props) => (
				<GrideDateFormatter
					date={props.dataItem.registeredTime}
					formatType={"dd.MM.yyyy"}
				/>
			),
			width: "120px",
		},

		{ field: "salesType", title: t("Type"), width: "80px" },

		{
			field: "liveWeightKg",
			title: t("Weight"),
			width: "150px",
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
			cells: {
				data: (props) => <NumericalCell {...props} unit={"kg"} />,
				headerCell: (props) => <NumericalHeader {...props} />,
			},
		},
		{
			field: "amount",
			title: t("Value"),
			width: "150px",
			cells: {
				data: (props) => <NumericalCell {...props} unit={"kr"} />,
				headerCell: (props) => <NumericalHeader {...props} />,
			},
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
		},
	];
	return gridItems;
};
